import type { IconOption } from '@/components/IconPicker'

// Curated set offered by the Bill icon picker. Every `name` must be a valid lucide-react
// dynamic icon name (see categoryIcon.tsx) — generic, recognizable glyphs (a bolt for
// "electricity"), not brand logos, matching how Account/Category icons already work here.
export const BILL_ICON_OPTIONS: IconOption[] = [
  { name: 'zap', label: 'Electricity' },
  { name: 'droplet', label: 'Water' },
  { name: 'flame', label: 'Gas / LPG' },
  { name: 'wifi', label: 'Broadband / WiFi' },
  { name: 'smartphone', label: 'Mobile' },
  { name: 'tv', label: 'DTH / Cable TV' },
  { name: 'home', label: 'Rent' },
  { name: 'building-2', label: 'Maintenance / Society' },
  { name: 'shield-check', label: 'Insurance Premium' },
  { name: 'receipt', label: 'Other' },
]

export const DEFAULT_BILL_ICON = 'receipt'

// Quick-add templates shown when Kind = Bill — tapping one pre-fills name + icon.
export const BILL_TEMPLATES: { name: string; icon: string }[] = [
  { name: 'Electricity Bill', icon: 'zap' },
  { name: 'Water Bill', icon: 'droplet' },
  { name: 'Gas / LPG', icon: 'flame' },
  { name: 'Broadband / WiFi', icon: 'wifi' },
  { name: 'Mobile Recharge', icon: 'smartphone' },
  { name: 'DTH / Cable TV', icon: 'tv' },
  { name: 'House Rent', icon: 'home' },
  { name: 'Maintenance / Society Charges', icon: 'building-2' },
  { name: 'Insurance Premium', icon: 'shield-check' },
]
